import React, { useEffect } from "react";
import { getYouTubeThumbFromUrl } from "../../../../utils/url";
import { Stand } from "../../../../data/interfaces";
import { STAND_MEDIA_TYPES } from "../../../../data/enums";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  stand: Stand;
}

const StandDetailHomeTabView = ({ stand, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[StandDetailHomeTabView] init");
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[StandDetailHomeTabView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------

  return (
    <>
      {/* <h3>{t("pages.standDetail.about.title")}</h3> */}
      <div className="description text-justify"
           dangerouslySetInnerHTML={{
             __html: stand?.description,
           }}>
      </div>
      <br/>
      <div className={"panel-content media-gallery"}>
        {stand && stand.media && stand.media.length > 0 ? (
          <ul>
            {stand.media.map((mediaEl) => {
              let thumbUrl: string = "";
              switch (mediaEl.type) {
                case STAND_MEDIA_TYPES.IMAGE:
                  thumbUrl = mediaEl.media_url;
                  break;
                case STAND_MEDIA_TYPES.VIDEO:
                  thumbUrl = getYouTubeThumbFromUrl(mediaEl.media_url);
                  break;
              }
              return (
                <li
                  className={`img-responsive ${
                    mediaEl.type === STAND_MEDIA_TYPES.IMAGE ? "image" : "video"
                  }`}
                  key={mediaEl.media_url + mediaEl.type} // fake unique key
                >
                  <a href={mediaEl.media_url} data-fancybox="media-gallery">
                    <img className={"img-responsive"} src={thumbUrl} alt={stand.name}/>
                  </a>
                </li>
              );
            })}
          </ul>
        ) : (
          <></>
          // <span>{t("pages.standDetail.tabs.noData")}</span>
        )}
      </div>
    </>
  );
};
export default StandDetailHomeTabView;
